import fp from 'lodash/fp';

export const tokenSelector = fp.compose(fp.get('PayPal.token'));
export const tokenIdSelector = fp.compose(fp.get('PayPal.tokenId'));
